var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNsConverters(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(7.000000, 4.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 11.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,0 L18,4.03150102 C18,5.6734431 16.6568542,7.5 15,7.5 L2,7.5",
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(2.000000, 7.500000) scale(-1, 1) translate(-2.000000, -7.500000) translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-19",
    points: "6.70796751e-13 -4.07229805e-13 3.56234741 3.5 6.70796751e-13 7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(8.500000, 6.500000) scale(-1, -1) translate(-8.500000, -6.500000) "
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.034058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,0.465942383 L17,4.4974434 C17,6.13938548 15.6568542,7.96594238 14,7.96594238 L1,7.96594238",
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(2.000000, 7.965942) scale(-1, 1) translate(-2.000000, -7.965942) translate(0.000000, 4.465942)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-19",
    points: "6.70796751e-13 -4.07229805e-13 3.5640564 3.5 6.70796751e-13 7"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.2, 1.2) translate(-1.5, -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(8.500000, 6.500000) scale(-1, -1) translate(-8.500000, -6.500000) "
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.07, 0.07) translate(-30 , 20)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1,
    fill: "#fff",
    d: "M116.586,118.12c1.795-4.607,4.297-8.588,7.511-11.961c3.225-3.389,7.114-6.016,11.667-7.898                 c4.547-1.904,9.633-2.845,15.262-2.845c7.261,0,13.32,0.995,18.183,2.997c4.857,1.996,8.768,4.482,11.738,7.441                 c2.964,2.97,5.091,6.168,6.369,9.584c1.273,3.432,1.915,6.636,1.915,9.595c0,4.901-0.642,8.947-1.915,12.118                 c-1.278,3.171-2.866,5.88-4.759,8.131c-1.898,2.252-3.987,4.172-6.293,5.755c-2.295,1.588-4.471,3.171-6.516,4.759                 c-2.045,1.583-3.862,3.394-5.445,5.439c-1.588,2.04-2.589,4.601-2.991,7.664v5.831H140.6v-6.908                 c0.305-4.395,1.153-8.072,2.529-11.036c1.382-2.964,2.991-5.499,4.83-7.598c1.844-2.089,3.786-3.911,5.836-5.445                 c2.04-1.539,3.927-3.073,5.673-4.591c1.73-1.545,3.144-3.225,4.221-5.069c1.071-1.833,1.556-4.15,1.452-6.908                 c0-4.705-1.148-8.18-3.454-10.427c-2.295-2.257-5.493-3.378-9.589-3.378c-2.758,0-5.134,0.533-7.131,1.605                 s-3.628,2.513-4.911,4.302c-1.278,1.795-2.225,3.894-2.834,6.288c-0.615,2.415-0.919,4.982-0.919,7.756h-22.55                 C113.85,127.785,114.791,122.732,116.586,118.12z M162.536,183.938v23.616h-24.09v-23.616H162.536z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNsConverters);
export default __webpack_public_path__ + "static/media/ns-converters.f91819070456f128b8d2d96410c100bb.svg";
export { ForwardRef as ReactComponent };